<template>
  <b-modal class="modal-sm" id="modalAddressBook" size="xl" ref="addressBook-modal" :title="addressModal.modalData.title" :header-bg-variant="'secondary'" hide-backdrop okVariant="secondary" @show="showAddressBook()" @hide="[resetSearch(), resetModal('sub')]">
    <template slot="modal-header" slot-scope="{ close }">
      <h5 class="modal-title text-light"><fontAwesomeIcon :icon="['fas', 'address-book']" size="1x" class="mr-2"/> {{ addressModal.modalData.title }}</h5>
      <button aria-label="Close" class="close" data-dismiss="modal" type="button" @click="close()"><span aria-hidden="true" class="text-light">X</span></button>
    </template>
    <template slot="default" v-if="parent && parents.includes(parent)" slot-scope="{ close }">
      <div class="vld-parent text-center">
        <div autofocus>
          <loading
              :active.sync="modalIsBusy"
              :can-cancel="false"
              :color="'#047bf8'"
              :loader="'dots'"
              :is-full-page="false">
          </loading>
          <div v-if="!modalIsBusy">
            <template v-if="addressBookData">
              <div class="element-wrapper element-box">
                <div>
                  <div class="element">
                    <div class="row">
                      <div class="col-12 col-sm-6 col-md-8">
                        <div class="element-info-with-icon mb-0">
                          <div class="element-info-icon">
                            <span class="os-icon os-icon-search2"></span>
                          </div>
                          <div class="element-info-text text-left">
                            <h5 class="element-inner-header">{{ t('labelSearchInContacts','labelSearchInContacts') }}</h5>
                            <div class="element-inner-desc">{{ t('descSearchInContacts','descSearchInContacts') }}</div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-sm-3 col-md-4">
                        <i id="contactsToggle" v-b-toggle.contacts-search class="os-icon os-icon-arrow-up float-right text-netsend-blue showhand"></i>
                      </div>
                    </div>
                  </div>
                  <b-collapse v-model="searchToggle" id="contacts-search" >
                    <form v-on:submit.prevent="searchInContacts" class="mt-3">
                      <div class="row">
                        <div class="col-lg-4">
                          <div class="form-group">
                            <label for="contact-customer-reference" class="d-block text-center">{{t('searchLabelCustomerRef','searchLabelCustomerRef') }}</label>
                            <input id="contact-customer-reference" v-model="searchArray.customer_reference" class="form-control text-center" :placeholder="t('searchLabelCustomerRef','searchLabelCustomerRef')" type="text">
                          </div>
                        </div>
                        <template v-if="parent === parents[1]">
                          <div class="col-lg-4">
                            <div class="form-group">
                              <label for="contact-customer-name" class="d-block text-center">{{t('searchLabelCustomerName','searchLabelCustomerName') }}</label>
                              <input id="contact-customer-name" v-model="contactSearch.customer_name" class="form-control text-center" :placeholder="t('searchLabelCustomerName','searchLabelCustomerName')" type="text">
                            </div>
                          </div>
                          <div class="col-lg-4">
                            <div class="form-group">
                              <label for="contact-customer-fax" class="d-block text-center">{{t('searchLabelCustomerFax','searchLabelCustomerFax') }}</label>
                              <input id="contact-customer-fax" v-model="contactSearch.customer_fax" class="form-control text-center" :placeholder="t('searchLabelCustomerFax','searchLabelCustomerFax')" type="text">
                            </div>
                          </div>
                        </template>
                        <template v-else-if="parent === parents[0]">
                          <div class="col-lg-4">
                            <div class="form-group">
                              <label for="contact-user-name" class="d-block text-center">{{t('searchLabelUserName','searchLabelUserName') }}</label>
                              <input id="contact-user-name" v-model="contactSearch.user_name" class="form-control text-center" :placeholder="t('searchLabelUserName','searchLabelUserName')" type="text">
                            </div>
                          </div>
                          <div class="col-lg-4">
                            <div class="form-group">
                              <label for="contact-user-email" class="d-block text-center">{{t('searchLabelUserEmail','searchLabelUserEmail') }}</label>
                              <input id="contact-user-email" v-model="contactSearch.user_email" class="form-control text-center" :placeholder="t('searchLabelUserEmail','searchLabelUserEmail')" type="text">
                            </div>
                          </div>
                        </template>
                      </div>
                      <div class="row">
                        <div class="col-lg-12">
                          <button v-if="!buttonIsBusy" class="btn btn-primary float-lg-right float-sm-none ml-2" type="submit">{{ t('searchButtonText','searchButtonText') }}</button>
                          <b-button v-if="buttonIsBusy" class="float-lg-right float-sm-none ml-2" variant="primary" disabled>
                            <b-spinner small type="grow"></b-spinner>
                            {{ t('searchButtonText','searchButtonText') }}
                          </b-button>
                        </div>
                      </div>
                    </form>
                  </b-collapse>
                </div>
              </div>
              <div class="mt-5">
                <h5 v-if="parent === parents[1]">{{t('labelCustomers', 'labelCustomers')}}</h5>
                <h5 v-else-if="parent === parents[0]">{{t('labelUsers', 'labelUsers')}}</h5>
                <div class="form-group controls-below-table row">
                  <div class="col-lg-4 col-sm-12 pt-3">
                    <b-input-group>
                      <b-input-group-prepend>
                        <label class="input-group-text">{{ t('recordsPerPageText', 'recordsPerPageText') }}</label>
                      </b-input-group-prepend>
                      <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                    </b-input-group>
                  </div>
                  <div class="col-lg-2 col-sm-12 pt-3 text-right">
                    <b-pagination class="float-right mb-0" v-model="currentPage" :total-rows="contactsData.length" :per-page="perPage" aria-controls="addressbook-customers-table" v-if="contactsData.length"></b-pagination>
                  </div>
                </div>
                <b-table id="addressbook-customers-table" striped hover bordered :responsive="true" class="mt-3" :per-page="perPage" :currentPage="currentPage"
                         :items="contactsData" :fields="fields" :total-rows="contactsData.length" :busy.sync="loading" :show-empty="true"
                         :thead-class="'brand-color'">
                  <template class="busy-row" slot="table-busy" slot-scope="items" v-bind:value="contactsData">
                    <vcl-table :rows="3" :columns="fields.length"></vcl-table>
                  </template>
                  <template v-slot:head(customer_ref)="data">
                    <span> {{ t(data.label, data.label) }}</span>
                  </template>
                  <template v-slot:head(name)="data">
                    <span> {{ t(data.label, data.label) }}</span>
                  </template>
                  <template v-slot:head(contact)="data">
                    <span> {{ t(data.label, data.label) }}</span>
                  </template>
                  <template v-slot:head(head_user)="data">
                    <span> {{ t(data.label, data.label) }}</span>
                  </template>
                  <template v-slot:head(primary_contact)="data">
                    <span> {{ t(data.label, data.label) }}</span>
                  </template>
                  <template v-slot:head(chase_contact)="data">
                    <span> {{ t(data.label, data.label) }}</span>
                  </template>
                  <template v-slot:head(doc_type_names)="data">
                    <span> {{ t(data.label, data.label) }}</span>
                  </template>

                  <template v-slot:head(checkbox)="data">
                    <template v-if="!allContactsToggle">
                      <fontAwesomeIcon @click="checkAllContacts()" :icon="['far', 'square']" class="showhand" size="2x"/>
                    </template>
                    <template v-else>
                      <fontAwesomeIcon @click="unCheckAllContacts()" :icon="['far', 'check-square']" class="showhand" size="2x"/>
                    </template>
                  </template>
                  <template v-slot:cell(checkbox)="data">
                    <b-form-group>
                      <b-form-checkbox-group v-model="selectContacts" name="addresses" class="d-flex justify-content-center">
                          <b-form-checkbox class="mx-0" :value="data.item.contact"></b-form-checkbox>
                      </b-form-checkbox-group>
                    </b-form-group>
                  </template>

                  <template v-if="parent === parents[0]" v-slot:cell(head_user)="data">
                    <template v-if="data.item.head_user == 1">
                      <b-form-group class="d-flex justify-content-center">
                        <p>{{t('optionYes', 'optionYes')}}</p>
                      </b-form-group>
                    </template>
                    <template v-else>
                      <b-form-group class="d-flex justify-content-center">
                        <p>{{t('optionNo', 'optionNo')}}</p>
                      </b-form-group>
                    </template>
                  </template>
                  <template v-if="parent === parents[0]" v-slot:cell(primary_contact)="data">
                    <b-form-group class="d-flex justify-content-center">
                      <b-form-checkbox v-model="data.item.primary_contact" :disabled="true" :value="1" :unchecked-value="0"></b-form-checkbox>
                    </b-form-group>
                  </template>
                  <template v-if="parent === parents[0]" v-slot:cell(chase_contact)="data">
                    <b-form-group class="d-flex justify-content-center">
                      <b-form-checkbox v-model="data.item.chase_contact" :disabled="true" :value="1" :unchecked-value="0" ></b-form-checkbox>
                    </b-form-group>
                  </template>
                </b-table>
              </div>
              <div class="row align-items-baseline justify-content-between px-2">
                <p v-if="parent === parents[1]">
                  <span v-if="selectContacts.length"> {{selectContacts.length}} {{ (selectContacts.length == 1) ? t('labelCustomerSelected','labelCustomerSelected') : t('labelCustomersSelected','labelCustomersSelected')}}</span>
                </p>
                <p v-else-if="parent === parents[0]">
                  <span v-if="selectContacts.length"> {{selectContacts.length}} {{ (selectContacts.length == 1) ? t('labelUserSelected','labelUserSelected') : t('labelUsersSelected','labelUsersSelected')}}</span>
                </p>
              </div>
            </template>
            <template v-else>
              <p>{{t('contactsFoundError', 'contactsFoundError')}}</p>
            </template>
          </div>
        </div>
      </div>
    </template>
    <!-- NS-8779: Added to speed up modal window closing, VY -->
    <template slot="default" v-else slot-scope="{ close }">
      <p>{{t('contactsFoundError', 'contactsFoundError')}}</p>
    </template>
    <template slot="modal-footer" slot-scope="{ cancel, close }">
        <button aria-label="Cancel" data-dismiss="modal" class="btn btn-secondary" type="button" @click="cancel()">
          <fontAwesomeIcon :icon="['fa', 'ban']" class="text-light mr-2"/>{{ t('cancelAndCloseButtonText', 'cancelAndCloseButtonText')}}
        </button>
        <template v-if="!modalIsBusy && !buttonIsBusy">
          <button aria-label="AddRecipientsModal" data-dismiss="modal" class="btn btn-primary" type="button" @click="[addToRecipients(), close()]">
            <fontAwesomeIcon :icon="['fa', 'user-edit']" class="text-light mr-2"/> {{ t('updateRecipientsButtonText', 'updateRecipientsButtonText')}}
          </button>
        </template>
        <template v-else>
          <button class="btn btn-primary" type="button" disabled>
            <fontAwesomeIcon :icon="['fa', 'user-edit']" class="text-light mr-2"/> {{ t('updateRecipientsButtonText', 'updateRecipientsButtonText')}}
          </button>
        </template>
    </template>
  </b-modal>
</template>

<script>
import Loading from 'vue-loading-overlay'
import { VclTable } from 'vue-content-loading'

export default {
  name: 'ModalAddressBook',
  //this component inherits from the Search.vue component
  inject: [
    'resetModal',
    'changeRecipients',
    'userLevel'
  ],
  props: ['contacts'],
  data () {
    return {
      parents: ['email', 'fax'],
      loading: false,
      searchToggle: true,
      selectContacts: [],
      searchArray: {
        customer_reference: ''
      },
      contactSearch: {
        user_email: '',
        customer_reference: '',
        user_name: '',
        customer_fax: '',
        customer_name: ''
      },
      addressModal: {},
      fieldsForCustomers: [
        {
          key: 'customer_ref',
          label: 'labelReference',
          sortable: true
        },
        {
          key: 'name',
          label: 'labelName',
          sortable: true
        },
        {
          key: 'contact',
          label: 'labelFax',
          sortable: true
        },
        {
          key: 'checkbox',
          label: ''
        }
      ],
      fieldsForUsers: [
        {
          key: 'customer_ref',
          label: 'labelReference',
          sortable: true
        },
        {
          key: 'name',
          label: 'labelName',
          sortable: true
        },
        {
          key: 'contact',
          label: 'labelEmail',
          sortable: true
        },
        {
          key: 'head_user',
          label: 'labelHeadUser',
          sortable: true
        },
        {
          key: 'primary_contact',
          label: 'labelNotifyUser',
          sortable: true
        },
        {
          key: 'chase_contact',
          label: 'labelUserRemind',
          sortable: true
        },
        {
          key: 'doc_type_names',
          label: 'labelDocTypeNames',
          sortable: false
        },
        {
          key: 'checkbox',
          label: ''
        }
      ],
      buttonIsBusy: false,
      modalIsBusy: false,
      currentPage: 1,
      perPage: 5,
      pageOptions: [5, 10, 20, 50],
    }
  },
  computed:{
    allContactsToggle: {
      get() {
        let selected = this.selectContacts
        for (let i = 0; i < this.allContacts.length; i++) {
          if (!selected.includes(this.allContacts[i])) {
            return false
          }
        }
        return true
      }
    },
    allContacts: {
      get() {
        let contacts = this.contactsData
        let result = []
        if (contacts && Array.isArray(contacts) && contacts.length) {
          for (let i = 0; i < contacts.length; i++) {
            if (contacts[i].contact && contacts[i].contact.length && !result.includes(contacts[i].contact)) {
              result.push(contacts[i].contact)
            }
          }
        }
        return result
      }
    },
    addressBookData: {
      get() {
        let data = this.$store.getters['addressBookStore/getAddressBook']

        if (data !== undefined) {
          return data.addressbook
        }

        return null
      }
    },
    fields: {
      get() {
        if (this.parent === this.parents[0]) {
          return this.fieldsForUsers
        }

        if (this.parent === this.parents[1]) {
          return this.fieldsForCustomers
        }

        return null
      }
    },
    parent: {
      get() {
        return this.addressModal.modalData.parent
      }
    },
    contactsData: {
      get() {
        if (this.addressBookData && this.addressBookData.contacts !== undefined) {
          return this.addressBookData.contacts;
        }
        return null
      }
    },
    selectedDocs: {
      get() {
        let docId = this.addressModal.docuData.docsChecked

        if (!docId) {
          docId = []
        }

        return docId
      }
    },
    selectedCustomers: {
      get() {
        let references = this.addressModal.docuData.statuses;
        let result = []
        if (references && Array.isArray(references) && references.length) {
          for (let i = 0; i < references.length; i++) {
            if (references[i].customer && references[i].customer.length && !result.includes(references[i].customer)) {
              result.push(references[i].customer)
            }
          }
        }
        return result
      }
    }
  },
  methods:{
    checkAllContacts() {
      this.selectContacts = this.allContacts
    },
    unCheckAllContacts() {
      let exist = this.selectContacts
      exist = exist.filter(item => !this.allContacts.includes(item))
      this.selectContacts = exist
    },
    showAddressBook() {
      this.selectContacts = this.contacts
      this.modalIsBusy = true
      this.loading = true
      this.buttonIsBusy = true
      this.contactSearch.customer_reference = this.selectedCustomers
      this.searchArray.customer_reference = this.selectedCustomers.join(',')
      this.$store.dispatch('addressBookStore/searchAddressBook', {
        filter: this.contactSearch,
        userLevel: this.userLevel,
        docId: this.selectedDocs,
        type: this.addressModal.modalData.parent
      }).finally(() => {
        this.modalIsBusy = false
        this.loading = false
        this.buttonIsBusy = false
      })
    },
    resetSearch() {
      this.currentPage = 1
      this.perPage = 5
      this.searchToggle = true
      this.clearSearch()
    },
    resetAddressBook() {
      this.resetSearch()
      this.selectContacts = []
    },
    addToRecipients() {
      this.changeRecipients(this.selectContacts)
    },
    searchInContacts() {
      this.loading = true
      this.buttonIsBusy = true
      this.currentPage = 1

      if (this.searchArray.customer_reference.length !== 0) {
        if ((typeof this.searchArray.customer_reference === 'string') && this.searchArray.customer_reference.includes(',')) {
          let referenceArray = this.searchArray.customer_reference.split(',')
          Object.keys(referenceArray).forEach((key) => (referenceArray[key] = referenceArray[key].trim() ))
          referenceArray = referenceArray.filter(function(value, index, arr){
            return value !== "";
          });
          this.searchArray.customer_reference = referenceArray
        } else if (typeof this.searchArray.customer_reference == 'string') {
          this.searchArray.customer_reference = this.searchArray.customer_reference.trim()
        }
        this.contactSearch.customer_reference = this.searchArray.customer_reference
      } else {
        this.contactSearch.customer_reference = ''
      }

      this.$store.dispatch('addressBookStore/searchAddressBook', {
        filter: this.contactSearch,
        userLevel: this.userLevel,
        docId: this.selectedDocs,
        type: this.addressModal.modalData.parent
      }).finally(() => {
        this.loading = false
        this.buttonIsBusy = false
        this.searchToggle = false
      })
    },
    clearSearch() {
      this.contactSearch = {
        user_email: '',
        customer_reference: '',
        user_name: '',
        customer_fax: '',
        customer_name: ''
      }
    }
  },
  created() {
    this.addressModal = this.$attrs.modal
  },
  components:{
    Loading,
    VclTable
  }
}
</script>

<style scoped>

.table-responsive  >>> .brand-color {
  background-color: #047bf8 !important;
  color: white !important;
}

.text-netsend-blue {
  color: #047bf8;
}

#contactsToggle{
  font-size: 1.2rem;
  font-weight: bold;
  display:inline-block;
  -moz-transition: all .5s linear;
  -webkit-transition: all .5s linear;
  transition: all .5s linear;
}
#contactsToggle.collapsed{
  -moz-transform:rotate(180deg);
  -webkit-transform:rotate(180deg);
  transform:rotate(180deg);
}

.showhand{
  cursor: pointer;
}
</style>
